/**
 * Configuration object for infinite caching.
 *
 * @property {boolean} refetchOnWindowFocus - Determines whether to refetch when the window gains focus. Default is false.
 * @property {boolean} refetchOnMount - Determines whether to refetch when the component mounts. Default is false.
 * @property {boolean} refetchOnReconnect - Determines whether to refetch when the network reconnects. Default is false.
 * @property {number} staleTime - The time in milliseconds after which a cache entry becomes stale. Default is 24 hours.
 * @property {number} cacheTime - The maximum time in milliseconds that cache entries will be retained. Default is 24 hours.
 * @property {number} retry - The number of times to retry a failed query. Default is 1.
 */
export const infiniteCacheConfig = {
  staleTime: Number.POSITIVE_INFINITY, // Cache will never become stale
  cacheTime: Number.POSITIVE_INFINITY, // Cache entries will be retained indefinitely
  refetchOnWindowFocus: false,
  refetchOnMount: false,
  refetchOnReconnect: false,
  retry: 0, // No retries will be attempted
}
